module.exports = __webpack_public_path__ + "final.00b9aaa4.png";